import { createContext } from 'react';

import { AgreementFromGetById } from '@/models/agreements';
import { NullablePriceAmount } from '@/utils/price';

type AgreementEditContextType = {
  draft: AgreementFromGetById;
  updateDraft: (partialDraft: Partial<AgreementFromGetById>) => void;
  updatePrice: (priceId: string, partialPrice: Partial<NullablePriceAmount>) => void;
  isUpdateAgreementPending: boolean;
};

export const AgreementEditContext = createContext<AgreementEditContextType>(
  {} as AgreementEditContextType
);
